var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "handle-coupon" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "handle-coupon-body",
        attrs: {
          "element-loading-text": "获取信息中...",
          "element-loading-spinner": "el-icon-loading",
        },
      },
      [
        _c(
          "div",
          { staticClass: "base-info" },
          [
            _vm.info.coupon.distributionCustomersName
              ? _c("el-row", { staticClass: "base-info-item" }, [
                  _c("label", { staticClass: "item-label" }, [
                    _vm._v("小程序公司："),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getFirstCustomerName(
                          _vm.info.coupon.distributionCustomersName
                        ) || "--"
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("el-row", { staticClass: "base-info-item" }, [
              _c("label", { staticClass: "item-label" }, [
                _vm._v("优惠券名称："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _vm._v(_vm._s(_vm.info.coupon.name || "--")),
              ]),
            ]),
            _vm._v(" "),
            _c("el-row", { staticClass: "base-info-item" }, [
              _c("label", { staticClass: "item-label" }, [
                _vm._v("领用时间："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _vm._v(
                  _vm._s(
                    (_vm.info.coupon.startTime || "") +
                      " - " +
                      (_vm.info.coupon.endTime || "")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("el-row", { staticClass: "base-info-item" }, [
              _c("label", { staticClass: "item-label" }, [
                _vm._v("券有效期："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _vm._v(
                  _vm._s(
                    _vm.info.coupon && _vm.info.coupon.validityType == 1
                      ? "领取后" + (_vm.info.coupon.validityDays || "--") + "天"
                      : _vm.info.coupon.validityStart +
                          " - " +
                          _vm.info.coupon.validityEnd
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.discountLines.length
              ? _c("el-row", { staticClass: "base-info-item" }, [
                  _c("label", { staticClass: "item-label" }, [
                    _vm._v("优惠内容："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item-value" },
                    _vm._l(_vm.discountLines, function (item, index) {
                      return _c("div", { key: index }, [
                        _vm._v(
                          "\n            " + _vm._s(item) + "\n          "
                        ),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.info.coupon && _vm.info.coupon.maxDiscount
              ? _c("el-row", { staticClass: "base-info-item" }, [
                  _c("label", { staticClass: "item-label" }, [
                    _vm._v("最高："),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-value" }, [
                    _vm._v(_vm._s(_vm.formatYuan(_vm.info.coupon.maxDiscount))),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isAdmin
          ? [
              _c("h3", [_vm._v("优惠效果总览")]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cards" },
                _vm._l(_vm.cards, function (item, index) {
                  return _c(
                    "el-card",
                    { key: index, attrs: { shadow: "always" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("span", [_vm._v(_vm._s(item.title))])]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.formatCardValue(item, _vm.info[item.value])
                            )
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "coupon-chart" }, [
                _c("div", { staticClass: "coupon-chart-item" }, [
                  _c("span", [
                    _vm._v(
                      " 优惠券发放总数：" +
                        _vm._s(_vm.info.totalDistributionCount)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chart" }, [
                    _vm._v("优惠券发放总量"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", [_vm._v("发放领取转换量")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(_vm._s(_vm.info.distributionToReceiveRate)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "coupon-chart-item" }, [
                  _c("span", [
                    _vm._v(
                      " 优惠券领取总数：" + _vm._s(_vm.info.totalReceiveCount)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chart" }, [_vm._v("优惠券领取量")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", [_vm._v("领取下单转换量")]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.info.receiveToOrderRate))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "coupon-chart-item" }, [
                  _c("span", [
                    _vm._v(
                      " 优惠券使用总数：" + _vm._s(_vm.info.totalUseCount)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chart" }, [
                    _vm._v("优惠券使用总量"),
                  ]),
                ]),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("h3", [_vm._v("平台效果统计")]),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _vm.isAdmin
          ? _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "小程序客户：" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "380px" },
                        attrs: { clearable: "", multiple: "" },
                        on: { change: _vm.getDetail },
                        model: {
                          value: _vm.searchForm.customerIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "customerIds", $$v)
                          },
                          expression: "searchForm.customerIds",
                        },
                      },
                      _vm._l(
                        _vm.commonData.distributionCustomers,
                        function (opt) {
                          return _c("el-option", {
                            key: opt.id,
                            attrs: { value: opt.id, label: opt.name },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "统计时间：" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "380px" },
                      attrs: {
                        type: "datetimerange",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": _vm.timeFormat,
                      },
                      on: { change: _vm.getDetail },
                      model: {
                        value: _vm.searchForm.time,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "time", $$v)
                        },
                        expression: "searchForm.time",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "show-goods" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                attrs: {
                  data: _vm.tableData.list,
                  "cell-style": _vm.tableCellStyle,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "小程序客户",
                    prop: "customerResponse",
                    align: "left",
                    "min-width": "220",
                    formatter: _vm.customerFormatter,
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "领取统计",
                    align: "center",
                    "min-width": "180",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              "总领取：" + _vm._s(scope.row.receivedCount || 0)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "主动领取：" +
                                _vm._s(scope.row.manualReceiveCount || 0)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "后台发放：" +
                                _vm._s(scope.row.backendIssueCount || 0)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "购买发放：" +
                                _vm._s(scope.row.purchaseIssueCount || 0)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "积分兑换：" +
                                _vm._s(
                                  scope.row.integralExchangeIssueCount || 0
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          Number(_vm.info.coupon.isGenerateCode) === 1
                            ? _c("div", [
                                _vm._v(
                                  "券码绑定：" +
                                    _vm._s(scope.row.codeBindIssueCount || 0)
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "使用张数",
                    prop: "usedCount",
                    align: "center",
                    "min-width": "100",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "成交单量",
                    prop: "transactionVolume",
                    align: "center",
                    width: "100",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "成交金额",
                    prop: "totalTransactionAmount",
                    align: "center",
                    "min-width": "150",
                    formatter: _vm.formatYuanColumn,
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "优惠金额",
                    prop: "totalDiscountAmount",
                    align: "center",
                    "min-width": "150",
                    formatter: _vm.formatYuanColumn,
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "客单价",
                    prop: "customerUnitPrice",
                    align: "center",
                    "min-width": "150",
                    formatter: _vm.formatYuanColumn,
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "成交客户数",
                    prop: "customerCount",
                    align: "center",
                    width: "200",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "成交商品件数",
                    prop: "productItemCount",
                    align: "center",
                    width: "200",
                    "show-overflow-tooltip": "",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("div", { staticClass: "top" }),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("div", { staticClass: "top" }),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }